import styled, { css } from "styled-components";

export const Outer = styled.div`
    position: relative;
    overflow: hidden;
`;

export const Track = styled.div`
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    padding-top: 24px;
    padding-bottom: 24px;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Items = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
`;

interface ItemProps {
    last: boolean;
    width: number;
    gutter: number;
}

export const Item = styled.div<ItemProps>`
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    width: ${({ width }) => width}px;
    margin-right: 10px;

    ${({ last, gutter }) =>
        last &&
        css`
            &::after {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                right: -${gutter}px;
                width: ${gutter}px;
                height: 100%;
            }
        `}
`;
